import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import Modal from "@/components/Modal";
import { toast } from "sonner";
import { Copy, Check, KeyRound, ShieldCheck } from "lucide-react";

export default function CompanyCodeModal({ onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/companies/me")
      .then((r) => setData(r.data))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, []);

  const copy = async () => {
    if (!data?.access_code) return;
    try {
      await navigator.clipboard.writeText(data.access_code);
      setCopied(true);
      toast.success("Code copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy");
    }
  };

  return (
    <Modal title="Company Access Code" onClose={onClose} testId="company-code-modal">
      {loading ? (
        <div className="text-center py-10 text-muted-foreground font-bold uppercase tracking-wider">Loading...</div>
      ) : !data ? (
        <div className="text-center py-10 text-muted-foreground font-bold uppercase tracking-wider">Unavailable</div>
      ) : (
        <>
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-muted-foreground mb-3">
            <ShieldCheck className="w-4 h-4 text-safety-yellow" /> {data.name}
          </div>

          <div className="border-2 border-safety-yellow bg-safety-yellow/10 px-4 py-6 text-center mb-4">
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-muted-foreground mb-2">Access Code</div>
            <div data-testid="company-code-value"
              className="font-mono text-5xl md:text-6xl font-black tracking-[0.25em] text-safety-yellow leading-none">
              {data.access_code}
            </div>
          </div>

          <button data-testid="company-code-copy" onClick={copy}
            className="btn-primary w-full">
            {copied ? <><Check className="w-5 h-5 mr-2" strokeWidth={3} /> Copied!</>
                    : <><Copy className="w-5 h-5 mr-2" strokeWidth={3} /> Copy Code</>}
          </button>

          <div className="mt-4 inline-flex items-start gap-2 text-xs text-muted-foreground">
            <KeyRound className="w-4 h-4 mt-0.5 text-safety-yellow flex-shrink-0" strokeWidth={2.5} />
            Share this code with new hires during registration.
          </div>
        </>
      )}
    </Modal>
  );
}
